import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import langEn from 'lang/lang.en';
import langKo from 'lang/lang.ko';
import langJa from 'lang/lang.ja';

const curLang = window.navigator.language.split('-')[0];

const resource = {
  en: {
    translation: langEn,
  },
  ko: {
    translation: langKo,
  },
  ja: {
    translation: langJa,
  },
};

i18n.use(initReactI18next).init({
  resources: resource,
  lng: navigator.language || 'en-US',
  fallbackLng: {
    'en': ['en'],
    'ja': ['ja'],
    'ko': ['ko'],
    default: ['en'],
  },
  debug: true,
  defaultNS: 'translation',
  ns: 'translation',
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
}, (err, t) => {
  // fallback language is english
  if (curLang !== 'en' && curLang !== 'ko' && curLang !== 'ja') {
    i18n.changeLanguage('en');
  }
});
export default i18n;
